(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["inbike-real-fit-reference"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-fit-toggle]');
    if (!toggle) return;

    const root = toggle.closest('.inbike-real-fit');
    if (!root) return;

    const willExpand = toggle.getAttribute('aria-expanded') !== 'true';
    root.querySelectorAll('[data-fit-extra]').forEach((card) => {
      card.hidden = !willExpand;
    });

    toggle.setAttribute('aria-expanded', String(willExpand));
    toggle.textContent = willExpand ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;
  });
  } catch(e) { console.error(e); }
})();

})();
